import React, { ReactElement } from 'react';
import packageJson from '../../../../package.json';
import constants from "../../../constants";

// version from response - first param, local version second param
const semverGreaterThan = (
  versionA: string,
  versionB: string,
) => {
  const versionsA = versionA.split(/\./g);

  const versionsB = versionB.split(/\./g);
  while (versionsA.length || versionsB.length) {
    const a = Number(versionsA.shift());

    const b = Number(versionsB.shift());
    // eslint-disable-next-line no-continue
    if (a === b) continue;
    // eslint-disable-next-line no-restricted-globals
    return a > b || isNaN(b);
  }
  return false;
};

interface IProps {
  children(
    loading: Boolean,
    isLatestVersion: Boolean,
    refreshCacheAndReload: Function,
  ): ReactElement;
}

interface IState {
  loading: Boolean;
  isLatestVersion: Boolean;
  refreshCacheAndReload: Function;
}

class CacheBuster extends React.PureComponent<
  IProps,
  IState
> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      loading: true,
      isLatestVersion: false,
      refreshCacheAndReload: () => {
        console.log('Clearing cache and hard reloading...');
        if (caches) {
          // Service worker cache should be cleared with caches.delete()
          caches.keys().then(names => {
            for (let name of names) caches.delete(name);
          });
        }

        // delete browser cache and hard reload
        window.location.reload();
      },
    };
  }

  componentDidMount() {
    // BASE_URL="/" + "/meta.json" → "//meta.json" (protocol-relative, sai).
    // Dùng constants.BASE_URL (đã chuẩn hóa "/" thành "").
    const metaUrl = `${constants.BASE_URL}/meta.json`;
    fetch(metaUrl)
      .then(response => response.json())
      .then(meta => {
        const latestVersion = meta.version;
        const currentVersion = packageJson.version;

        const shouldForceRefresh = semverGreaterThan(
          latestVersion,
          currentVersion,
        );
        if (shouldForceRefresh) {
          console.log(
            `We have a new version - ${latestVersion}. Should force refresh`,
          );
          this.setState({
            loading: false,
            isLatestVersion: false,
          });
        } else {
          this.setState({
            loading: false,
            isLatestVersion: true,
          });
        }
      })
      .catch(() => {
        // Không chặn app nếu không lấy được meta.json
        this.setState({
          loading: false,
          isLatestVersion: true,
        });
      });
  }

  render() {
    let {
      loading,
      isLatestVersion,
      refreshCacheAndReload,
    } = this.state;
    return this.props.children(
      loading,
      isLatestVersion,
      refreshCacheAndReload,
    );
  }
}

export default CacheBuster;
